import React from 'react';
import PropTypes from 'prop-types';

import Arrow from '../../atoms/arrow/Arrow';
import styles from './filterNav.module.scss';

const FilterNav = ({
	headingName = 'Filters',
	lableName = 'Reset All',
	backbtn,
	resetClickHandler,
	isCategoryError,
	selectedFilter,
	filterType = ""
}) => {
	return (
		<nav className={styles.header}>
			<Arrow back={backbtn} id={`${headingName}-filter-nav-bckBtn`}/>
			<h2 className={styles.heading}>{headingName}</h2>
			<button 
				onClick={resetClickHandler} 
				className={filterType == "filter_by_product"
							? (selectedFilter?.search ? styles.btnReset : styles.hideBtnReset)
							: (selectedFilter?styles.btnReset:styles.hideBtnReset)
						} 
				
				id={`${headingName}-resetBtn`}
			>
				{(headingName == "Filter deals" || headingName == "Filter products") ? lableName :"Reset"}
			</button>
		</nav>
	);
};

FilterNav.propTypes = {
	backbtn: PropTypes.func,
	lableName: PropTypes.string,
	headingName: PropTypes.string,
	resetClickHandler: PropTypes.func,
	selectedFilter:PropTypes.object,
	filterType: PropTypes.string,
};

export default FilterNav;